/**
 * Action types for apis functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle list of apis.
 */

// Get apis constants
export const APIS_REQUEST_GET = 'APIS_REQUEST_GET';
export const APIS_RESPONSE_GET_SUCCESS = 'APIS_RESPONSE_GET_SUCCESS';
export const APIS_RESPONSE_GET_FAIL = 'APIS_RESPONSE_GET_FAIL';

export const PC_LIST = 'PC_LIST';
export const PC_LIST_SUCCESS = 'PC_LIST_SUCCESS';
export const PC_LIST_FAIL = 'PC_LIST_FAIL';

export const PC_DOWNLOAD = 'PC_DOWNLOAD';
export const PC_DOWNLOAD_SUCCESS = 'PC_DOWNLOAD_SUCCESS';
export const PC_DOWNLOAD_FAIL = 'PC_DOWNLOAD_FAIL';

export const PC_STOP = 'PC_STOP';
export const PC_STOP_SUCCESS = 'PC_STOP_SUCCESS';
export const PC_STOP_FAIL = 'PC_STOP_FAIL';

export const PC_RESET = 'PC_RESET';

export const PC_DELETE = 'PC_DELETE';
export const PC_DELETE_SUCCESS = 'PC_DELETE_SUCCESS';
export const PC_DELETE_FAIL = 'PC_DELETE_FAIL';

export const PC_ADD = 'PC_ADD';
export const PC_ADD_SUCCESS = 'PC_ADD_SUCCESS';
export const PC_ADD_FAIL = 'PC_ADD_FAIL';
